import { Contract } from "../types";
import { StatusBadge } from "./StatusBadge";
import { ArrowRight } from "lucide-react";

export function ContractCard({
  contract,
  active,
  onClick,
}: {
  contract: Contract;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`relative text-left px-3 py-3 cursor-pointer flex flex-col gap-2 transition-colors w-full border-l-4 ${
        active
          ? "bg-[#FDF1E8C2] border-l-[#F1935C]"
          : "bg-white border-l-transparent hover:bg-[#F9FAFB]"
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="text-[12px] font-semibold text-[#525062] flex items-center flex-wrap flex-1 min-w-0 gap-1">
          <span>{contract.from}</span>
          <ArrowRight className="w-3.5 h-3.5 text-[#E2682B] shrink-0" />
          <span>{contract.to}</span>
        </div>
        <StatusBadge status={contract.status} />
      </div>

      <div className="border-t border-dashed border-[#E7E7E7] w-full" />

      <div className="grid grid-cols-3 gap-4">
        <Metric label="Supply Period" value={String(contract.supplyPeriod)} />
        <Metric
          label="Return Period"
          value={String(contract.returnPeriod)}
          highlight
        />
        <Metric label="Banking Factor" value={contract.bf} />
      </div>
    </button>
  );
}

function Metric({
  label,
  value,
  highlight,
}: {
  label: string;
  value: string;
  highlight?: boolean;
}) {
  return (
    <div className="flex flex-col gap-1">
      <div className="text-[11px] text-[#828A99] font-medium leading-tight">
        {label}
      </div>
      <div
        className={`text-[12px] font-bold ${
          highlight ? "text-[#C8311C]" : "text-[#525062]"
        }`}
      >
        {value}
      </div>
    </div>
  );
}

export default ContractCard;
